import React from 'react';
import { MinimalTeamManagement } from '@/components/teams/MinimalTeamManagement';

const TeamDemoPage: React.FC = () => {
  return <MinimalTeamManagement />;
};

export default TeamDemoPage;
